import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getDispatchRiderFacets } from "../services";

export const useRiderFacets = (
  isApiConfigReady: boolean = false,
  activeTab?: string,
  refetchIntervalMs?: number
) => {
  const { data, isLoading, refetch, dataUpdatedAt } = useQuery({
    queryKey: ["riderFacets", activeTab],
    queryFn: () => getDispatchRiderFacets({}, activeTab),
    enabled: isApiConfigReady,
    staleTime: refetchIntervalMs || 10 * 60 * 1000,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  const filteredRiders = useMemo(() => {
    return data?.riders || [];
  }, [data?.riders]);

  return {
    facets: data,
    loading: isLoading,
    filteredRiders,
    refetch,
    dataUpdatedAt,
  };
};
